/**
 * 各端页面表：菜单 routeName → 懒加载 .vue + 页签行为。
 * 由 apps/{admin,manage,customer}/router/routePages.ts 在启动时 registerRoutePages。
 */
import type { RouteComponent } from "vue-router";

export interface RoutePageConfig {
    /** 直接 `() => import("../views/....vue")`，不要再写路径字符串 */
    component: RouteComponent;
    /** 禁止用户固定页签 */
    noPin?: boolean;
    /**
     * 添加/编辑共用同一 .vue、但 route.name 不同时写入，keep-alive 才不会拆成两份。
     * 不配则缓存 key 用路由 name（后端 routeName）。
     */
    keepAliveName?: string;
}

let registry: Record<string, RoutePageConfig> = {};

function normalizeRouteName(raw: string | undefined): string {
    const name = String(raw || "").trim();
    if (!name || name.includes("/")) return "";
    return name;
}

/** 覆盖本端全部页面配置（启动时调用一次）；key 为 Vue Router name */
export function registerRoutePages(pages: Record<string, RoutePageConfig>): void {
    const next: Record<string, RoutePageConfig> = {};
    for (const [routeName, config] of Object.entries(pages)) {
        const key = normalizeRouteName(routeName);
        if (!key) continue;
        next[key] = config;
    }
    registry = next;
}

export function getRoutePageExtra(routeName: string | undefined): RoutePageConfig | undefined {
    const key = normalizeRouteName(routeName);
    return key ? registry[key] : undefined;
}

export function isRouteNoPin(routeName: string | undefined): boolean {
    return getRoutePageExtra(routeName)?.noPin === true;
}

export function resolvePageComponent(routeName: string | undefined): RouteComponent | undefined {
    return getRoutePageExtra(routeName)?.component;
}

export function listRegisteredRouteNames(): string[] {
    return Object.keys(registry);
}
